module.exports = new __parcel__URL__("10438252-1.5073f1af.png").toString();